import { supabase } from '@/integrations/supabase/client';

export interface SecurityEvent {
  action: 'login' | 'logout' | 'password_change' | 'admin_access' | 'data_export' | 'failed_login' | 'suspicious_activity';
  userId?: string;
  details?: Record<string, any>;
  success?: boolean;
}

export const logSecurityEvent = async (event: SecurityEvent) => {
  try {
    const { error } = await supabase.rpc('log_security_event', {
      p_user_id: event.userId || null,
      p_action: event.action,
      p_success: event.success ?? true,
      p_details: event.details || null
    });

    if (error) {
      console.warn('Failed to log security event:', error);
    }
  } catch (error) {
    console.warn('Error logging security event:', error);
  }
};

export const logAdminAccess = async (userId: string, action: string, details?: Record<string, any>) => {
  await logSecurityEvent({
    action: 'admin_access',
    userId,
    details: { admin_action: action, ...details },
    success: true
  });
};

export const logFailedLogin = async (details?: Record<string, any>) => {
  await logSecurityEvent({
    action: 'failed_login',
    details,
    success: false
  });
};